const formulaFunctions = new Map();
formulaFunctions.set('ABS', Math.abs);
// functions to expose in a formula expression
export default formulaFunctions;
